import React, { useState } from 'react';
import { setOptions } from 'store/card/options';
import { RootState } from 'types/store';

import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'lib/hooks/redux';

import Select from 'components/common/Select';
import AlertBadge from 'components/common/AlertBadge';

export const CybersourceOptions = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation('error');
    const [error, setError] = useState<null | string>(null);

    const pm = useAppSelector((state: RootState) => state.paymentMethod);
    const card = useAppSelector((state) => state.card);

    const cyb = pm.types.cybersource;
    const options = cyb.data?.id ? card.options[cyb.data?.id] : null;
    const installment = cyb.data?.card?.installments ?? 1;

    const handleChangeInstallments = async (n: string) => {
        setError(null);

        try {
            const resp = await dispatch(
                setOptions({
                    paymentMethod: 'Cybersource',
                    paymentId: cyb.data?.id ?? '',
                    installments: parseInt(n),
                }),
            ).unwrap();

            if (resp?.success == false) throw new Error(resp?.message);
        } catch (err) {
            setError(t('cybInstallmentError.message'));
        }
    };

    const installments =
        options?.installments.map((n) => {
            const value = n.toString(10);
            return { value, label: n <= 1 ? '1 cuota' : `${value} cuotas` };
        }) || [];

    return (
        <div>
            <Select
                label="Número de cuotas"
                options={installments}
                empty={installments.length && installments[0].value == '1' ? false : '1 cuota'}
                onChange={handleChangeInstallments}
                value={installment.toString()}
            />
            {error && (
                <div style={{ marginBottom: '1em' }}>
                    <AlertBadge theme="danger" size="large">
                        {error}
                    </AlertBadge>
                </div>
            )}
        </div>
    );
};
